import React from 'react';

class Section1 extends React.Component {
    render() { 
        return <React.Fragment><div className="container">
        <div className="card">
          <div className="card-img"><img src="https://health.clevelandclinic.org/wp-content/uploads/sites/3/2013/10/vitaminSupplemnts-499257708-770x553.jpg" alt="" srcset="" /></div>
          <div className="card-text">Shop Multivitamin</div>
        </div>
        <div className="card">
          <div className="card-img"><img src="https://dlye1hka1kz5z.cloudfront.net/media/blog_images/How_Many_Calories_are_in_One_Gram_of_Protein_2x.jpg" alt="" srcset="" /><span className="label">NEW</span></div>
          <div className="card-text">Shop Protein</div>
        </div>
        <div className="card">
          <div className="card-img"><img src="https://oshiprint.in/image/data/poster/new/mqp1489.jpeg" alt="" srcset="" /></div>
          <div className="card-text">Shop Pregnancy</div>
        </div>
        <div className="card">
          <div className="card-img"><img src="https://img.freepik.com/free-photo/lovely-couple-have-warm-cuddle_273609-44073.jpg?size=626&ext=jpg" alt="" srcset="" /><span className="label">SAVE $10</span></div>
          <div className="card-text">Shop Bundles</div>
        </div>
      </div>
      <div id="info-box">
        <h2>
          Daily essentials with good intentions — for living life or creating
          it.
        </h2>
        <div className="container">
          <div className="info-card">
            <svg width="40" height="40" version="1.1" viewBox="0 0 40 40">
              <g
                fill="none"
                fill-rule="evenodd"
                stroke="none"
                stroke-width="1"
              >
                <g fill="#142B6F" stroke="#142B6F" stroke-width=".3">
                  <g>
                    <g>
                      <g>
                        <g>
                          <path
                            d="M15.8204013,21.8128245 C10.6631121,21.8128245 6.40325523,17.8863477 5.87287779,12.867125 L5.97390206,12.867125 C6.55984285,12.867125 7.0329732,12.3923109 7.0329732,11.8063701 C7.0329732,11.2204294 6.55984285,10.747299 5.97390206,10.747299 L5.87287779,10.747299 C6.40325523,5.72639259 10.6631121,1.79991581 15.8204013,1.79991581 C20.9776905,1.79991581 25.2375474,5.72639259 25.7679248,10.747299 L25.6669005,10.747299 C25.0809597,10.747299 24.6078294,11.2204294 24.6078294,11.8063701 C24.6078294,12.3923109 25.0809597,12.867125 25.6669005,12.867125 L25.7679248,12.867125 C25.2375474,17.8863477 20.9776905,21.8128245 15.8204013,21.8128245 M35.6901922,11.0823628 L31.3478322,6.74000281 C30.9353164,6.32748702 30.2786586,6.32748702 29.8998176,6.74000281 C29.4856181,7.15420233 29.4856181,7.80917637 29.8998176,8.1880174 L32.4843553,10.7725551 L27.5728918,10.7725551 C27.0475656,4.7447734 21.9811983,0 15.8204013,0 C9.66802301,0 4.60670689,4.73130349 4.06791076,10.747299 L1.0573874,10.747299 C0.473130349,10.747299 0,11.2204294 0,11.8063701 C0,12.3923109 0.473130349,12.867125 1.0573874,12.867125 L4.06791076,12.867125 C4.60670689,18.8814368 9.66802301,23.6127403 15.8204013,23.6127403 C21.9811983,23.6127403 27.0475656,18.8679669 27.5728918,12.8401852 L32.4843553,12.8401852 L29.8998176,15.4264066 C29.4856181,15.8389224 29.4856181,16.4955802 29.8998176,16.8727375 C30.3123334,17.286937 30.9689912,17.286937 31.3478322,16.8727375 L35.6901922,12.5303774 C35.897292,12.3232777 36,12.0471447 36,11.8080539 C36,11.5319209 35.897292,11.2894626 35.6901922,11.0823628 M11.4431879,10.7469623 L9.25601235,10.7469623 C8.6717553,10.7469623 8.19525747,11.2200926 8.19525747,11.8060334 C8.19525747,12.3936579 8.6717553,12.8667883 9.25601235,12.8667883 L11.4431879,12.8667883 C12.0308124,12.8667883 12.5039428,12.3936579 12.5039428,11.8060334 C12.5039428,11.2200926 12.0308124,10.7469623 11.4431879,10.7469623 M16.9138207,10.7469623 L14.7249614,10.7469623 C14.1407044,10.7469623 13.6658903,11.2200926 13.6658903,11.8060334 C13.6658903,12.3936579 14.1407044,12.8667883 14.7249614,12.8667883 L16.9138207,12.8667883 C17.4997615,12.8667883 17.9728918,12.3936579 17.9728918,11.8060334 C17.9728918,11.2200926 17.4997615,10.7469623 16.9138207,10.7469623 M22.3842851,10.7469623 L20.1971096,10.7469623 C19.6128525,10.7469623 19.1363547,11.2200926 19.1363547,11.8060334 C19.1363547,12.3936579 19.6128525,12.8667883 20.1971096,12.8667883 L22.3842851,12.8667883 C22.9719096,12.8667883 23.44504,12.3936579 23.44504,11.8060334 C23.44504,11.2200926 22.9719096,10.7469623 22.3842851,10.7469623"
                            transform="translate(-375.000000, -1722.000000) translate(135.000000, 1524.000000) translate(0.000000, 118.000000) translate(240.000000, 80.000000) translate(2.000000, 8.000000)"
                          ></path>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
            <h4>Traceable Ingredients</h4>
          </div>
          <div className="info-card">
            <svg
              width="40"
              height="40"
              x="0"
              y="0"
              enable-background="new -5 -5 50 50"
              version="1.1"
              viewBox="-5 -5 50 50"

            >
              <path
                fill="#142B6F"
                d="M33.488,6.342c-0.014-0.014-0.018-0.033-0.031-0.047c-0.021-0.021-0.051-0.029-0.074-0.049	C29.92,2.876,25.201,0.791,20,0.791C9.408,0.791,0.791,9.408,0.791,20c0,10.592,8.617,19.209,19.209,19.209	c10.592,0,19.209-8.617,19.209-19.209C39.209,14.661,37.016,9.827,33.488,6.342z M20,3.791c3.868,0,7.418,1.365,10.208,3.633	L7.424,30.207C5.156,27.418,3.791,23.867,3.791,20C3.791,11.061,11.062,3.791,20,3.791z M20,36.209	c-3.992,0-7.646-1.457-10.473-3.859L32.35,9.526c2.402,2.828,3.859,6.481,3.859,10.474C36.209,28.938,28.938,36.209,20,36.209z"
              ></path>
            </svg>
            <h4>Non-GMO</h4>
          </div>
          <div className="info-card">
            <svg width="40" height="40" version="1.1" viewBox="0 0 40 40">
              <g
                fill="none"
                fill-rule="evenodd"
                stroke="none"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1"
              >
                <g stroke="#142B6F" stroke-width="2.4">
                  <g>
                    <g>
                      <g>
                        <g
                          transform="translate(-305.000000, -1722.000000) translate(135.000000, 1524.000000) translate(0.000000, 118.000000) translate(170.000000, 80.000000) translate(8.500000, 6.000000)"
                        >
                          <path
                            d="M12.0010534,0 C12.0010534,0 9.76360948,2.49026245 6.90886699,3.57316846 C6.09563407,3.88287115 4.61664571,4.11883511 3.23035747,4.28527397 C1.35528676,4.51491746 -0.0331082964,5.92016709 0.000600840003,7.57612841 C0.0490577236,9.99897259 0.16493288,13.5826752 0.43039233,17.1116004 C0.895999777,23.2824792 10.4736082,28.6569796 12.0010534,28.6569796 M12.0010534,0 C12.0010534,0 14.2363905,2.49026245 17.091133,3.57316846 C17.9043659,3.88287115 19.3854611,4.11883511 20.7696425,4.28527397 C22.6447132,4.51491746 24.0331083,5.92016709 23.9993992,7.57612841 C23.9509423,9.99897259 23.8371739,13.5826752 23.5696077,17.1116004 C23.1040002,23.2824792 13.5917033,28.6569796 12.0010534,28.6569796 M7.57757198,14.8918537 L10.567151,17.6370415 L16.4220067,11.0195167"
                          ></path>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
            <h4>Third Party Tested</h4>
          </div>
          <div className="info-card">
            <svg
              width="40"
              height="40"
              x="0"
              y="0"
              enable-background="new -5 -5 50 50"
              version="1.1"
              viewBox="-5 -5 50 50"

            >
              <path
                fill="#142B6F"
                d="M38.553,9.801c-0.281-0.282-0.662-0.44-1.06-0.44l-5.65-0.004h-0.01c-4.294,0-7.995,1.984-10.403,5.188	C20.822,7.054,15.315,1.55,8.16,1.545L2.51,1.541c-0.828,0-1.5,0.671-1.5,1.499L1.008,4.365c-0.003,4.347,1.691,8.44,4.771,11.524	s7.17,4.783,11.511,4.786l1.201,0.007l-0.004,5.306c0,0.001,0,0.001,0,0.001v0.001l-0.009,12.468l3,0.002l0.007-10.98l1.195-0.004	h0.015c4.382,0,8.451-1.499,11.456-4.221c3.117-2.822,4.837-6.752,4.84-11.066l0.001-1.325	C38.992,10.464,38.834,10.083,38.553,9.801z M17.298,17.675c-3.546-0.002-6.883-1.39-9.396-3.906	C5.431,11.293,4.051,8.022,4.01,4.542l4.148,0.003c5.959,0.004,10.306,4.765,10.336,11.31l-0.001,1.826L17.298,17.675z M32.138,21.03c-2.453,2.222-5.806,3.444-9.448,3.444h-0.013l-1.189,0.004v-0.793c0-0.008,0.004-0.016,0.004-0.023	c0.037-6.552,4.386-11.305,10.342-11.305h0.008l4.148,0.003C35.942,15.748,34.578,18.821,32.138,21.03z"
              ></path>
            </svg>
            <h4>Vegan</h4>
          </div>
          <div className="info-card">
            <svg width="40" height="40" version="1.1" viewBox="0 0 40 40">
              <g
                fill="none"
                fill-rule="evenodd"
                stroke="none"
                stroke-width="1"
              >
                <g fill="#142B6F" fill-rule="nonzero">
                  <g>
                    <g>
                      <g>
                        <g>
                          <path
                            d="M11.9777778,31.3444444 C5.75555556,31.3444444 0.622222222,26.2888889 0.622222222,19.9888889 C0.622222222,14.1555556 9.95555556,2.33333333 11.0444444,1.01111111 C11.5111111,0.466666667 12.4444444,0.466666667 12.8333333,1.01111111 C13.9222222,2.33333333 23.3333333,14.0777778 23.3333333,19.9888889 C23.3333333,26.2111111 18.2,31.3444444 11.9777778,31.3444444 Z M11.9777778,3.65555556 C8.78888889,7.77777778 2.95555556,16.1 2.95555556,19.9888889 C2.95555556,24.9666667 7,29.0111111 11.9777778,29.0111111 C16.9555556,29.0111111 21,24.9666667 21,19.9888889 C21,16.1 15.1666667,7.7 11.9777778,3.65555556 Z"
                            transform="translate(-515.000000, -528.000000) translate(135.000000, 410.000000) translate(0.000000, 118.000000) translate(380.000000, 0.000000) translate(8.333333, 4.166667)"
                          ></path>
                          <path
                            d="M11.9,25.9 C11.2777778,25.9 10.7333333,25.3555556 10.7333333,24.7333333 C10.7333333,24.1111111 11.2777778,23.5666667 11.9,23.5666667 C14.3888889,23.5666667 16.4111111,21.5444444 16.4111111,19.0555556 C16.4111111,18.4333333 16.9555556,17.8888889 17.5777778,17.8888889 C18.2,17.8888889 18.7444444,18.4333333 18.7444444,19.0555556 C18.7444444,22.8666667 15.6333333,25.9 11.9,25.9 Z"
                            transform="translate(-515.000000, -528.000000) translate(135.000000, 410.000000) translate(0.000000, 118.000000) translate(380.000000, 0.000000) translate(8.333333, 4.166667)"
                          ></path>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
            <h4>No Artificial Flavors or Synthetic Fillers</h4>
          </div>
        </div>
      </div></React.Fragment>;
    }
}
 
export default Section1;